// Building definitions
export const BUILDINGS = {
  // Original buildings
  farm: {
    wood: 5,
    stone: 0,
    metal: 0,
    name: 'Farm',
    benefit: '+1 to all Farm rolls',
    category: 'utility',
    effects: {
      taskBonuses: [
        { task: 'farm', type: 'perWorker', value: 1 }
      ]
    }
  },
  wall: {
    wood: 0,
    stone: 8,
    metal: 0,
    name: 'Wall',
    benefit: '+3 defense during raids',
    category: 'utility'
  },
  granary: {
    wood: 5,
    stone: 3,
    metal: 0,
    name: 'Granary',
    benefit: 'Food spoilage halved',
    category: 'utility'
  },
  workshop: {
    wood: 6,
    stone: 6,
    metal: 0,
    name: 'Workshop',
    benefit: 'Generate 1 tech point/day, enables research',
    category: 'utility',
    effects: {
      passiveGeneration: {
        resource: 'techPoints',
        amount: 1
      }
    }
  },

  // New utility buildings
  hospital: {
    wood: 8,
    stone: 5,
    metal: 3,
    name: 'Hospital',
    benefit: 'Enables treat task, reduces disease chance by 80%',
    category: 'utility'
  },
  barracks: {
    wood: 10,
    stone: 8,
    metal: 5,
    name: 'Barracks',
    benefit: '+2 to guard rolls, guard workers immune to push injury',
    category: 'utility',
    effects: {
      taskBonuses: [
        { task: 'guard', type: 'flat', value: 2 },
        { task: 'guard', type: 'immunity', pushInjuryImmunity: true }
      ]
    }
  },
  library: {
    wood: 12,
    stone: 4,
    metal: 0,
    name: 'Library',
    benefit: 'Enables study task to generate knowledge',
    category: 'utility'
  },
  forge: {
    wood: 8,
    stone: 10,
    metal: 8,
    name: 'Forge',
    benefit: '+1 per worker on quarry, +1 to build rolls',
    category: 'utility',
    effects: {
      taskBonuses: [
        { task: 'quarry', type: 'perWorker', value: 1 },
        { task: 'build', type: 'flat', value: 1 }
      ]
    }
  },
  mine: {
    wood: 5,
    stone: 15,
    metal: 0,
    name: 'Mine',
    benefit: 'Enables mine task for metal (cave-in risk on rolls 1-2)',
    category: 'utility'
  },
  nursery: {
    wood: 10,
    stone: 3,
    metal: 0,
    name: 'Nursery',
    benefit: '+50% birth chance, children mature faster',
    category: 'utility'
  },
  marketplace: {
    wood: 15,
    stone: 8,
    metal: 2,
    name: 'Marketplace',
    benefit: 'Enables trade task for resource exchange',
    category: 'utility'
  },

  // Victory path buildings
  spaceport: {
    wood: 30,
    stone: 40,
    metal: 50,
    name: 'Spaceport',
    benefit: 'Launch into space (Victory Path)',
    category: 'victory',
    buildThreshold: 30,
    unlockConditions: {
      minDay: 12,
      requiredBuildings: ['workshop', 'forge'],
      requiredTech: 75
    }
  },
  temple: {
    wood: 25,
    stone: 35,
    metal: 0,
    name: 'Temple',
    benefit: '+3 knowledge/day, spiritual victory path',
    category: 'victory',
    buildThreshold: 25,
    unlockConditions: {
      minKnowledge: 60,
      minMorale: 75
    },
    effects: {
      passiveGeneration: {
        resource: 'knowledge',
        amount: 3,
        cap: 'KNOWLEDGE_CAP'
      }
    }
  },
  fortress: {
    wood: 15,
    stone: 50,
    metal: 30,
    name: 'Fortress',
    benefit: '+5 defense, conquest victory path',
    category: 'victory',
    buildThreshold: 25,
    unlockConditions: {
      minDay: 14,
      requiredBuildings: ['barracks', 'wall'],
      raidsDefeated: 3
    }
  },
  monument: {
    wood: 40,
    stone: 40,
    metal: 20,
    name: 'Monument',
    benefit: '+10 morale on completion, prosperity path',
    category: 'victory',
    buildThreshold: 30,
    completionEffects: { morale: 10 },
    unlockConditions: {
      minDay: 15,
      minPopulation: 10,
      requiredBuildings: ['farm', 'granary', 'library', 'hospital', 'marketplace']
    }
  }
};
